export default __webpack_public_path__ + "img/1004e50fa847bbe31786b4911f8c68f8.png";